module.exports = __webpack_public_path__ + "img/12.09aba259.png";